<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-card-title
                style="background-color: #009688; color: white;"
            >
                History for: &nbsp;<v-chip>{{ data && data.DIA_T }}</v-chip>
            </v-card-title>
            <v-card-text style="padding-top: 15px;">
                <v-textarea
                    v-model="placeholderData.HISTORY"
                    :single-line="true"
                    hide-details
                    outlined
                    color="teal darken-1"
                    :readonly="true"
                    label="test2"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="teal darken-1 white--text"
                    width="120"
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                    close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    mdiClose
} from '@mdi/js'
export default {
    props: ['show', 'data'],
    data: () =>({
        mdiClose,
        placeholderData: {
            DIA_T: null,
            HISTORY: null
        }
    }),
    computed: {
        showDialog: {
            get() {
                this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        initData() {
            if (this.data) {
                this.placeholderData = structuredClone(this.data)
            }
        }
    }
}
</script>
